module.exports = __webpack_public_path__ + "img/weather.979231df.png";